<template>
    <div>  
        <v-row style="text-align: center; padding: 15px; background-color: #ffffff;" justify="center">
            <v-spacer></v-spacer>
            <v-col cols="3" md="2">
                <div class="stat-cards mx-2 my-2">
                    <v-flex sm12>
                        Users
                    </v-flex>
                    <v-flex sm12>
                        {{ recentStats.users }}
                    </v-flex>
                </div>
            </v-col>
            <v-col cols="3" md="2">
                <div class="stat-cards mx-2 my-2">
                    <v-flex sm12>
                        Active
                    </v-flex>
                    <v-flex sm12>
                        {{ recentStats.active }}
                    </v-flex>
                </div>
            </v-col>
            <v-col cols="3" md="2">
                <div class="stat-cards mx-2 my-2">
                    <v-flex sm12>
                        Upgrades
                    </v-flex>
                    <v-flex sm12>
                        {{ recentStats.upgrades }}
                    </v-flex>
                </div>
            </v-col>
            <v-col cols="3" md="2">
                <div class="stat-cards mx-2 my-2">
                    <v-flex sm12>
                        Logins
                    </v-flex>
                    <v-flex sm12>
                        {{ recentStats.logins }}
                    </v-flex>
                </div>
            </v-col>
            <v-col cols="3" md="2">
                <div class="stat-cards mx-2 my-2">
                    <v-flex sm12>
                        Active
                    </v-flex>
                    <v-flex sm12>
                        {{ recentStats.activationRate }}%
                    </v-flex>
                </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12">
                <chartjs-line :width="300" :height="300" :labels="labels" :datasets="datasets" :option="options" :bind="true"/>
            </v-col>
            <v-row justify="center">
                <v-col cols="3" md="2">
                    <v-btn color="#454545" elevation="0" class="button-style" dark @click="statsTicker = 1000; getStatsHistory()">All Time</v-btn>
                </v-col>
                <v-col cols="3" md="2">
                    <v-btn color="#454545" elevation="0" class="button-style" dark @click="statsTicker = 52; getStatsHistory()">Last Year</v-btn>
                </v-col>
                <v-col cols="3" md="2">
                    <v-btn color="#454545" elevation="0" class="button-style" dark @click="statsTicker = 26; getStatsHistory()">Last 6 Months</v-btn>
                </v-col>
                <v-col cols="3" md="2">
                    <v-btn color="#454545" elevation="0" class="button-style" dark @click="statsTicker = 13; getStatsHistory()">Last Quarter</v-btn>
                </v-col>
                <v-col cols="3" md="2">
                    <v-btn color="#454545" elevation="0" class="button-style" dark @click="statsTicker = 4; getStatsHistory()">Last Month</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" class="mt-3">
                <v-data-table must-sort :options="options" :headers="headers" :items="statsHistory">
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    name: 'ClientStats',
    data(){
        return { 
            recentStats: {},
            statsTicker: 52,
            headers: [
                { text: 'Date', value: 'realTime' },
                { text: 'Users', value: 'users' },
                { text: 'Active', value: 'active' },
                { text: 'Upgrades', value: 'upgrades' },
                { text: 'Logins', value: 'logins' },
                { text: 'PLogins', value: 'pLogins' },
                { text: 'Active %', value: 'activationRate'}
            ],
            options:{
                itemsPerPage: 10
            },
            clientStatsNew: {
                users: 0,
                active: 0,
                upgrades: 0,
                logins: 0,
                promoters: 0,
                neutral: 0,
                detractors: 0
            },
            statsHistory: [],
            labels: [],
            datasets: [ 
                {
                    label: "Users",
                    fill: false,
                    backgroundColor: '#202020',
                    borderColor: '#202020',
                    data: [],
                    lineTension: 0.3
                },
                {
                    label: "Active",
                    fill: false,
                    backgroundColor: '#45a766',
                    borderColor: '#45a766',
                    data: [],
                    lineTension: 0.3
                },
                {
                    label: "Upgrades",
                    fill: false,
                    backgroundColor: '#45a766',
                    borderColor: '#45a766',
                    data: [],
                    lineTension: 0.3
                },
                {
                    label: "Logins",
                    fill: false,
                    backgroundColor: '#7F7FD8',
                    borderColor: '#7F7FD8',
                    data: [],
                    lineTension: 0.3
                }
            ],
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        stacked: false,
                        ticks: {
                            fontColor: "#202020",
                            fontSize: 10,
                            // stepSize: 500,
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true,
                            color: "#e2e2e2"
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontColor: "#202020",
                            fontSize: 10,
                            stepSize: 50,
                            beginAtZero: true
                        },
                        gridLines: {
                            display: true,
                            color: "#e2e2e2"
                        }
                    }]
                },
                animation: {
                    duration: 750,
                },
                legend: {
                    labels: {
                        fontColor: "#202020",
                        fontSize: 11
                    }
                },
                tooltips: {
                    mode: 'index'
                },
                elements: {
                    point:{
                        radius: 0
                    }
                }
            }
        }
    },
    methods: {
        getStatsHistory(){
            firebase.firestore().collection('stats').doc('kpis').collection('totals').onSnapshot(snapshot => {
            // reset things
                this.labels = []
                let stats = []
                this.labels = []
                this.datasets[0].data = []
                this.datasets[1].data = []
                this.datasets[2].data = [] 
                this.datasets[3].data = []
            // populate stats array
                snapshot.forEach(doc => {
                    let tempStats = doc.data()
                    tempStats.realTime = moment(tempStats.time).format('DD/MM/YY')
                    stats.unshift(tempStats)
                })
                this.statsHistory = stats
            // define array length for line chart
                if(stats.length < this.statsTicker){
                    this.statsTicker = stats.length
                }
            // populate array of objects for line chart
                for(var i = 0; i < this.statsTicker; i++){
                    this.labels.unshift(stats[i].realTime)
                    this.datasets[0].data.unshift(stats[i].users)
                    this.datasets[1].data.unshift(stats[i].active)
                    this.datasets[2].data.unshift(stats[i].upgrades)
                    this.datasets[3].data.unshift(stats[i].logins)
                }
            }, err => { console.log(`Encountered error: ${err}`) })
        // get recent stats for main header
            firebase.firestore().collection('stats').doc('kpis').onSnapshot(docSnapshot => {
                this.recentStats = docSnapshot.data()
            }, err => { console.log(`Encountered error: ${err}`) })
        },
    },
    mounted(){
        this.getStatsHistory()
    }
}
</script>
<style>
.stat-cards{
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    color: #202020;
    padding: 10px;
}
.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
  width: 80vw;
}
hr{ 
  height: 1px;
  color: rgb(94, 94, 94);
  background-color: rgb(94, 94, 94);
  border: none;
}
</style>
